import script from "./LeftTitle.vue?vue&type=script&lang=ts&setup=true"
export * from "./LeftTitle.vue?vue&type=script&lang=ts&setup=true"

import "./LeftTitle.vue?vue&type=style&index=0&id=27ce3f06&scoped=true&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27ce3f06"]])

export default __exports__